import axios from 'axios'

const api = axios.create({
    // Production par défaut : le .env n'est pas versionné, donc sans ce repli
    // un build qui oublie la variable produit `baseURL: undefined`. Axios
    // bascule alors en URL relatives et le SPA s'appelle lui-même — il reçoit
    // son propre index.html et échoue à le parser, ce qui ne ressemble pas du
    // tout à la cause. Le local surcharge via retailers-frontend/.env.
    //
    // Le préfixe /retailers dit l'audience ; tout le backend est servi sur
    // api.baltic-watches.com.
    baseURL:
        (import.meta.env.VITE_API_URL || 'https://api.baltic-watches.com') +
        '/retailers',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
})

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
})

api.interceptors.response.use(
    (response) => response.data,
    (error) => {
        if (error.response?.status === 401 && localStorage.getItem('token')) {
            localStorage.removeItem('token')
            window.location.href = '/'
        }
        // Same key the API answers errors with, so callers read one field.
        throw error.response?.data || { error_message: 'Network error' }
    }
)

export default api
